import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalsService } from 'src/app/core/services/globals.service';

@Component({
  selector: 'FullScreen',
  templateUrl: './full-inner-screen.component.html',
  styleUrls: ['./full-inner-screen.component.scss']
})
export class FullInnerScreenComponent implements OnInit, OnDestroy {

  constructor(private globalservice: GlobalsService) {
  }

  ngOnInit(): void {
    this.globalservice.innerRoute = true;
  }
  ngOnDestroy(): void {
    this.globalservice.innerRoute = false;
  }
}
